import { createApp } from 'vue'
import App from './App.vue'


createApp(App).mount('#app')



import './assets/tailwind.css'
import 'flowbite';